<template>
  <PivotFieldSection
    v-if="!disableCols"
    v-model="config"
    caption="Columns"
    group="group"
    :readonly
    :section="PivotTableGroup.COLS"
  />
  <PivotFieldSection
    v-model="config"
    caption="Rows"
    group="group"
    :readonly
    :section="PivotTableGroup.ROWS"
  />
  <PivotFieldSection
    v-model="config"
    caption="Values"
    :readonly
    :section="PivotTableGroup.VALUES"
  />
</template>

<script setup lang="ts">
import { PivotTableConfig, PivotTableGroup } from '@types'

import PivotFieldSection from './PivotFieldSection.vue'

interface Props {
  readonly?: boolean
  disableCols?: boolean
}

defineProps<Props>()

const config = defineModel<PivotTableConfig>()
</script>
